<template>
    <v-menu
        v-if="items.length"
        v-model="isOpen"
        close-on-click
        close-on-content-click
        content-class="overflow-y-hidden dropmenu"
        bottom
        offset-y
        :left="!openMenuRight"
        :right="openMenuRight"
        :below="openMenuBelow"
        :absolute="absolute"
    >
        <template v-slot:activator="{ on: menuOn }">
            <slot name="activator" :on="menuOn" :is-open="isOpen">
                <v-tooltip :disabled="!tooltip" bottom>
                    <template v-slot:activator="{ on: tooltipOn }">
                        <icon-button :icon="icon" :on="{ ...menuOn, ...tooltipOn }"/>
                    </template>
                    {{ tooltip }}
                </v-tooltip>
            </slot>
        </template>

        <v-list :class="wide ? 'wide' : ''" dense>
            <v-list-item v-if="title" class="mb-2">
                <v-list-item-title style="line-height: unset" class="title">{{ title }}</v-list-item-title>
            </v-list-item>

            <template v-for="(item, index) in items">
                <v-menu
                    v-if="showSubMenu(item)"
                    :key="index"
                    close-on-click
                    close-on-content-click
                    offset-x right open-on-hover
                    max-height="320"
                >
                    <template v-slot:activator="{ on: subMenuOn }">
                        <ActionMenuItem
                            v-on="subMenuOn"
                            :key="index"
                            :item="item"
                            :has-sub-menu="true"
                            :on="subMenuOn"
                        />
                    </template>
                    <v-list>
                        <template v-for="(subItem, subIndex) in item.value">
                            <ActionMenuItem
                                :item="subItem"
                                :key="subIndex"
                                @action="onSubActionClick(index, subIndex)"
                            />
                        </template>
                    </v-list>
                </v-menu>
                <ActionMenuItem
                    v-else
                    :key="index"
                    :item="item"
                    @action="onActionClick(index)"
                />
            </template>
            <slot name="bottom"/>
        </v-list>
    </v-menu>
</template>

<script>
import {ref} from "@vue/composition-api";
import ActionMenuItem from "../../ActionMenuItem.vue";

export default {
    name: "ActionMenu",
    components: {ActionMenuItem},
    props: {
        items: {
            type: Array,
            default: () => []
        },
        icon: {
            type: String,
            default: 'MoreVertical'
        },
        isNew: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        wide: {
            type: Boolean,
            default: false
        },
        absolute: {
            type: Boolean,
            default: true
        },
        openMenuRight: {
            type: Boolean,
            default: false
        },
        openMenuBelow: {
            type: Boolean,
            default: false
        },
    },
    setup(props, ctx) {
        const isOpen = ref(false);
        const onActionClick = (index) => {
            ctx.emit('action', index)
        }

        const onSubActionClick = (index, subIndex) => {
            ctx.emit('subAction', {index: index, subIndex: subIndex})
        }

        const showSubMenu = (item) => {
            return Array.isArray(item.value)
        }


        return {
            onActionClick,
            onSubActionClick,
            showSubMenu,
            isOpen
        }
    }
}
</script>

<style scoped lang="scss">
.v-list.wide {
    ::v-deep .v-list-item {
        padding: 0 24px 0 20px;
    }
}
</style>